// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3_EAo","fileBtn":"File_fileBtn__28Uls","closeBtn":"File_closeBtn__2mkdz","fileSelected":"File_fileSelected__1wNoY","disabled":"File_disabled__fhlLU"};